import { logger } from './../logger/logger.class';
import { LOG_TYPE } from './../const/logger.const';
/**
 * Metrics method decorator - measures the time it takes to complete the method's task
 * @returns MethodDecorator
 * ```
 *  import { Metrics } from '@emobg/web-utils';
 * ```
 * ```@Metrics()```\
 * ```myMeasuredMethod()```
*/
export function Metrics() {
    return function (_target, propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            const start = performance.now();
            originalMethod.apply(this, args);
            const finish = performance.now();
            const milliseconds = (finish - start).toFixed(2);
            logger.message(`${propertyKey} completed in ${milliseconds} [ms]`, LOG_TYPE.info);
        };
        return descriptor;
    };
}
